import React, { useRef, useState } from "react";
import swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { getCurrentLanguageTexts } from "../../../../constants/seasonPassPersonalInfoLangs";
import { FillCompanyDataModal } from "./FillCompanyDataModal";
import { TicketsPicker } from "../../../OpenSell/TicketsPicker";
import CheckBox from "../../../../components/UI/Checkbox/CheckBox";
import TermsAndConditionsModal from "../../TermsAndConditionsModal/TermsAndConditionsModal";
import { getCurrencieLabel } from "../../../../constants/currencies";
import { executePayment } from "../../../../helpers/paymentHelper/paymentHelper.ts";
import { paymentTypes } from "../../../../constants/paymentType.ts";
import PleaseWait from "../../../../images/please-wait-season-pass-modal.svg";
import { paymentMethods, ticketTemplateIds } from "../../constants.js";
import Membership2025Adult from "../../../../images/membership2025-adult-new.jpg";
import Membership2025Child from "../../../../images/membership2025-child-new.jpg";
import Membership2026Adult from "../../../../images/membership2026-adult.png";
import Membership2026AdultCard from "../../../../images/membership2026-adult-card.png";
import Membership2026Child from "../../../../images/membership2026-child.png";
import Membership2026ChildCard from "../../../../images/membership2026-child-card.png";
import MembershipOld from "../../../../images/membership2025-child.png";
import { IconButton } from "../../../../components/UI/IconButton/IconButton.js";
import ls from 'localstorage-slim';
import { ticketTypes } from "../../../../helpers/ticketHelper.ts";

export const BuyMembershipModal = ({ text, handleBuy, title }) => {
  const [buyer, setBuyer] = useState("individual");

  const MySwal = withReactContent(swal);
  const { buyMembershipTxt, dataFormTxt } = getCurrentLanguageTexts();

  const handleChangeOption = (e) => {
    setBuyer(e.target.value);
  }

  const handleConfirm = () => {
    if (buyer === "individual") {
      handleBuy()
    } else {
      MySwal.fire({
        html: <FillCompanyDataModal handleBuy={(companyInfo, paymentType) => handleBuy(buyer, companyInfo, paymentType)} title={dataFormTxt.companyDataTitle} />,
        showConfirmButton: false,
        showCloseButton: true,
        customClass: "partizan-modal member-page-modal",
      });
    }
  }

  return (
    <div className="buy-membership-modal">
      <h2 className="first-title">{title}</h2>
      <p className="buy-membership-modal__title">{text}</p>

      <div className="buy-membership-modal__radio-wrapper">
        <label className="radiobutton">
          <input
            className="radiobutton__input"
            name="operation"
            type="radio"
            value="individual"
            onChange={handleChangeOption}
            checked={buyer === "individual"}
          />
          <span>{buyMembershipTxt.individualBuyer}</span>
        </label>
        <label className="radiobutton">
          <input
            className="radiobutton__input"
            name="operation"
            type="radio"
            value="company"
            onChange={handleChangeOption}
            checked={buyer === "company"}
          />
          <span>{buyMembershipTxt.companyBuyer}</span>
        </label>
      </div>

      <div className="swal2-actions">
        <button
          type='button'
          className='swal2-cancel swal2-styled'
          onClick={() => MySwal.close()}
        >
          {buyMembershipTxt.cancelBtn}
        </button>
        <button onClick={handleConfirm} className="swal2-confirm swal2-styled">
          {buyMembershipTxt.buyBtn}
        </button>
      </div>
    </div>
  )
}

export const BuyMembershipsModalNew = ({ eventData, userData, seat }) => {
  const MySwal = withReactContent(swal);
  const container = useRef();

  const { buyMembershipTxt, waitModalTxt } = getCurrentLanguageTexts();

  const [tickets, setTickets] = useState([]);
  const currencyCode = getCurrencieLabel(eventData.currencyId);
  const [paymentAmount, setPaymentAmount] = useState(0);
  const [isTermsChecked, setIsTermsChecked] = useState(false);
  const [isShowTerms, setIsShowTerms] = useState(false);
  const isOneSeatMode = !!seat;

  const showTermsAndConditionsModal = (ev) => {
    ev.preventDefault();
    setIsShowTerms(true);
  };

  const getTicketTemplates = () => {
    let ticks = [];
    ticks = eventData.ticketTemplates.filter((t, i, ar) => t.isAvailableToSale);

    ticks.forEach((t, i) => {
      ticks[i].imgUrl =
        ticketTemplateIds.child.includes(ticks[i].ticketTemplateId) && Membership2026Child
        || ticketTemplateIds.childCard.includes(ticks[i].ticketTemplateId) && Membership2026ChildCard
        || ticketTemplateIds.adult.includes(ticks[i].ticketTemplateId) && Membership2026Adult
        || ticketTemplateIds.adultCard.includes(ticks[i].ticketTemplateId) && Membership2026AdultCard
        || MembershipOld;
    });

    return ticks;
  };


  const setPrice = (ticks) => {
    setPaymentAmount(
      ticks.reduce((accumulator, ticket) => {
        return accumulator + ticket.getPrice();
      }, 0)
    );
  };

  const onObjectSelected = (ticket) => {

    if (ticket.type === ticketTypes.NO_SEAT) {
      const ticks = [...tickets, ticket];

      setPrice(ticks);
      setTickets(ticks);
    }
  };

  const onObjectDeselected = (ticket) => {

    if (ticket.type === ticketTypes.NO_SEAT) {
      const index = tickets.findIndex(i => i.ticketTemplateId === ticket.ticketTemplateId);

      const ticks = tickets.filter((item, i) => i !== index);

      setPrice(ticks);
      setTickets(ticks);
    }
  };

  const createOrder = async (buyer, companyInfo, paymentOption) => {
    const isCashPaymentMode = ls.get('pageAction') === 'selling';

    let paymentType = paymentOption == 'invoice' ? paymentTypes.delayedPayment : paymentTypes.online;

    await executePayment({
      eventData: eventData,
      paymentProvider: isCashPaymentMode ? paymentMethods.OffPay : paymentMethods.LedPay,
      paymentType: paymentType,
      redirectUrl: window.location.href.includes('?') ? window.location.href + "&resultOrderId={id}"
        : window.location.href + "?resultOrderId={Id}",
      tickets: tickets,
      transaction: {
        fullName: userData.firstName + ' ' + userData.lastName,
        physicalAddress: userData.physicalAddress,
        city: userData.city,
        postalCode: userData.postalCode,
        phoneNumber: userData.phone,
        buyerEmail: userData.email,
        birthday: userData.dateOfBirth,
        gender: userData.gender,
        buyerCountry: 'Srbija',
        ...companyInfo,
      }
    })
  }

  const showPleaseWaitModal = () => {
    MySwal.fire({
      imageUrl: PleaseWait,
      title: waitModalTxt.title,
      text: waitModalTxt.description,
      allowEscapeKey: false,
      customClass: "partizan-modal seasonpass__modal partizan-info-modal",
      allowOutsideClick: false,
      allowEnterKey: false,
      showConfirmButton: false,
    });
  };

  const handleBuy = async (buyer, companyInfo, paymentOption) => {
    showPleaseWaitModal();

    if (isOneSeatMode) {
      tickets[0].area = seat.area;
      tickets[0].side = seat.side;
      tickets[0].row = seat.row;
      tickets[0].seat = seat.seat;
      tickets[0].fixedDiscount = 0;
      tickets[0].price = 1;
    }

    await createOrder(buyer, companyInfo, paymentOption);
  };

  const handleBuyMembership = () => {
    MySwal.fire({
      html: <BuyMembershipModal text={buyMembershipTxt.buyDescription} title={buyMembershipTxt.buyTitle} handleBuy={handleBuy} />,
      showConfirmButton: false,
      showCloseButton: true,
      customClass: "partizan-modal member-page-modal",
    });
  };

  const closeBtnHandler = () => {
    if (isShowTerms) {
      setIsShowTerms(false);
      container.current.scrollTo(0, 0);
    } else {
      MySwal.close();
    }
  }

  return (
    <div className="buy-membership-modal" ref={container}>
      <div style={{ display: isShowTerms ? 'none' : 'block' }}>
        <h2 className="first-title">{buyMembershipTxt.buyMembershipsListTitle}</h2>
        <div className="seasonpass-pers-info__tick-list">
          <TicketsPicker
            canSelect={
              tickets.length <
              (isOneSeatMode ? 1 : eventData.maxSeatsToSelectPerTransaction)
            }
            onObjectSelected={onObjectSelected}
            onObjectDeselected={onObjectDeselected}
            ticketTemplates={getTicketTemplates()}
            currency={currencyCode}
            tickets={tickets}
          />
        </div>
        <div className="seasonpass-pers-info__tick-total">
          <span className="">{buyMembershipTxt.total} </span>
          <span className="">
            {paymentAmount} {currencyCode}
          </span>
        </div>
        <CheckBox
          checked={isTermsChecked}
          id="terms-and-conditions-checkbox"
          name="terms-and-conditions-checkbox"
          onChange={() => setIsTermsChecked(!isTermsChecked)}
        >
          <span className="partizan-open-selling__text-medium-small">
            {buyMembershipTxt.iAgreeWith}
            <span
              className="partizan-open-selling__terms-of-service-text" style={{ color: '#d7b36c' }}
              onClick={showTermsAndConditionsModal}
            >
              {buyMembershipTxt.termsOfService}
            </span>
          </span>
        </CheckBox>
      </div>

      <div style={{ display: isShowTerms ? 'block' : 'none' }}>
        <TermsAndConditionsModal />
      </div>

      <div className="swal2-actions">
        {!isShowTerms
          ?
          <>
            <button
              type='button'
              className='swal2-cancel swal2-styled'
              onClick={() => MySwal.close()}
            >
              {buyMembershipTxt.cancelBtn}
            </button>
            <button disabled={!paymentAmount || !isTermsChecked} onClick={handleBuyMembership} className="swal2-confirm swal2-styled">
              {buyMembershipTxt.buyBtn}
            </button>
          </>
          : <button
            type='button'
            className='swal2-cancel swal2-styled'
            onClick={closeBtnHandler}
          >Ok</button>
        }
      </div>
    </div>
  )
}

